import { AppContextProvider } from '@bcecloud/frontend';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { createAuthAdapter, setupTokenRefresh } from '@/lib/auth';
import { MyEventsAuthProvider } from '@/components/MyEventsAuthProvider';
import { installAuthInterceptor } from '@/lib/clerk-token';
import { getRuntimeConfig } from '@/lib/runtime-config';
import { initViewAsFromUrl } from '@/lib/view-as';
import { setAuthPool } from '@/lib/auth-pool';
import { SIGN_IN_POOL } from '@bcecloud/portal-ui';
import './index.css';

// Send every API call directly to the API host (from runtime config) rather
// than through the same-origin /api proxy. Empty in dev → relative → Vite proxy.
axios.defaults.baseURL = getRuntimeConfig('API_BASE_URL') || '';

const auth = createAuthAdapter();

const config = {
  apiUrl: '/api/v3',
  organizations: {
    enabled: false,
    allowUserCreateOrganization: false,
  },
};

// Auto-refresh the legacy token before expiry. Still wired while password
// sign-in remains the fallback door; a Clerk session ignores it.
setupTokenRefresh();

// Prefers a Clerk session, falls back to the legacy cookie token. Installed
// before render so the very first request already carries whichever exists.
installAuthInterceptor();

// View-as deep links from the BCEcloud admin. Before render on purpose: the
// link flips the persisted auth pool to staff, and MyEventsAuthProvider reads
// that pool exactly once at mount.
initViewAsFromUrl(() => setAuthPool(SIGN_IN_POOL.staff));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <MyEventsAuthProvider>
        <AppContextProvider defaultTheme="light" auth={auth} config={config}>
          <App />
        </AppContextProvider>
      </MyEventsAuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
